import React from 'react'; // eslint-disable-line
import { useDispatch } from 'react-redux';
import {
  func, number, oneOf, string, arrayOf, any, bool,
} from 'prop-types';
import {
  ASYNC_JOB_STATUS_WAITING,
  ASYNC_JOB_STATUS_RUNNING,
} from '@picsio/db/src/constants';
import { resizePanel } from '../../store/actions/main';
import TranscriptPlaceholder from './components/TranscriptPlaceholder';
import TranscriptList from './components/TranscriptList';
import './styles.scss';

const TranscriptPanel = ({
  assetId,
  assetName,
  panelWidth,
  videoCurrentTime,
  setVideoPlayerCurrentTime,
  transcribing = 'skipped',
  transcript = [],
  transcriptPermission = false,
  transcriptLang = 'en',
  activeRevisionID = null,
  isLoaded = false,
  manageTranscriptPermission = false,
}) => {
  const dispatch = useDispatch();

  return (
    <div className="transcriptionsPanel" style={{ width: panelWidth }}>
      <div
        role="presentation"
        className="resizer"
        onMouseDown={(event) => dispatch(resizePanel(event, 'previewView.right'))}
      />
      <Choose>
        <When condition={(transcript.length > 0) && ![ASYNC_JOB_STATUS_RUNNING, ASYNC_JOB_STATUS_WAITING].includes(transcribing)}>
          <TranscriptList
            videoCurrentTime={videoCurrentTime}
            setVideoPlayerCurrentTime={setVideoPlayerCurrentTime}
            transcript={transcript}
            assetId={assetId}
            activeRevisionID={activeRevisionID}
            assetName={assetName}
            lang={transcriptLang}
            manageTranscriptPermission={manageTranscriptPermission}
            transcribing={transcribing}
          />
        </When>
        <Otherwise>
          <TranscriptPlaceholder
            transcribing={transcribing}
            assetId={assetId}
            transcriptPermission={transcriptPermission}
            assetName={assetName}
            activeRevisionID={activeRevisionID}
            isLoaded={isLoaded}
          />
        </Otherwise>
      </Choose>
    </div>
  );
};

TranscriptPanel.propTypes = {
  assetId: string.isRequired,
  assetName: string.isRequired,
  panelWidth: number.isRequired,
  setVideoPlayerCurrentTime: func.isRequired,
  videoCurrentTime: number.isRequired,
  transcribing: oneOf(['skipped', 'waiting', 'running', 'complete', 'failed', 'rejected']),
  transcript: arrayOf(any),
  transcriptPermission: bool,
  transcriptLang: string,
  activeRevisionID: string,
  isLoaded: bool,
  manageTranscriptPermission: bool,
};

export default TranscriptPanel;
